import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

import { useNoteFormContext } from '../../context/noteFormContext';
import TranscriptComponent from '../../transcript/transcript';

export const Transcript = () => {
  const { note } = useNoteFormContext();

  if (!note?.aiScribe?.transcript) return null;

  return <TranscriptComponent note={note as ClientProfileContentItem} />;
};
